import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const Privacy: React.FC = () => {
  return (
    <div className="privacy-page">
      <div className="container">
      <header>
  <h1>TT Saver - Privacy Policy</h1>
        <p className="subtitle">How we collect and use your information</p>
      </header>

  <p className="effective-date">Effective Date: October 7, 2025</p>

      <div className="section">
        <p>
          TT Saver (the "App") (hereinafter referred to as "we" or "our") values your privacy and is committed to protecting your personal information. By using the App,
          you agree to the collection, use, storage, and protection of your information as described in this Privacy Policy. Please read the following carefully.
        </p>
      </div>

      <div className="section">
        <h2>1. Information We Collect</h2>
        <ul>
          <li><strong>Device Information:</strong> Technical data such as device model, operating system version, unique device identifiers, etc.</li>
          <li><strong>App Usage Information:</strong> We collect analytics data regarding your usage habits, browsing history, and click data to improve our services.</li>
        </ul>
      </div>

      <div className="section">
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Provide and improve our services.</li>
          <li>Communicate with you for customer support or notifications.</li>
          <li>Analyze and optimize app performance and user experience.</li>
          <li>Provide personalized content and advertisements based on your needs and interests.</li>
        </ul>
      </div>

      <div className="section">
        <h2>3. How We Protect Your Information</h2>
        <p>
          We employ industry-standard security measures to protect your personal information, including encryption technology and access controls. However,
          please be aware that no method of data transmission over the internet is completely secure, so there is always some risk involved in transmitting data.
        </p>
      </div>

      <div className="section">
        <h2>4. Third-Party Service Providers</h2>
        <p>
          We may share your information with third-party service providers who assist us in processing your information. These providers will only access your information to the extent necessary to perform their services, and they are required to comply with our privacy policy.
        </p>
      </div>

      <div className="section">
        <h2>5. Information Sharing and Disclosure</h2>
        <ul>
          <li><strong>Legal Requirements:</strong> In response to legal processes such as court orders or government requests.</li>
          <li><strong>Protection of Rights:</strong> If we believe your actions violate our terms of service or policies, we may take necessary actions to protect our legal rights.</li>
        </ul>
      </div>

      <div className="section">
        <h2>6. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our services or legal requirements. Any changes will be posted on this page with an updated date. Please check this page periodically for updates.
        </p>
      </div>

      <div className="contact-info">
        <h2>CONTACT INFORMATION</h2>
        <p>If you have any questions or concerns regarding this Privacy Policy, or if you need more information, please contact us:</p>
        <p>Email: <a href="mailto:support@tsmallin.com">support@tsmallin.com</a></p>
        <p>Official Website: <Link to="/">ttsaver.tsmallin.com</Link></p>
      </div>

      <footer>
        <p>© {new Date().getFullYear()} TT Saver. All rights reserved.</p>
      </footer>
      </div>
    </div>
  );
};

export default Privacy;
